import { useEffect, useState } from 'react'
import { Copy } from 'lucide-react'
import { toast } from 'sonner'
import { useLocation } from 'react-router'
import type { FallbackProps } from 'react-error-boundary'
import { useAuthStore, type User } from 'shared/store/auth'
import { Button } from 'shared/components/ui/button'

export function ErrorFallbackMain({ resetErrorBoundary, error }: FallbackProps) {
	const { pathname } = useLocation()
	const [url] = useState(pathname)
	const { user } = useAuthStore()

	useEffect(() => {
		if (url !== pathname) resetErrorBoundary()
	}, [pathname, url, resetErrorBoundary])

	useEffect(() => {
		toast.error(<ErrorMessageMain user={user} pathname={pathname} />)
	}, [error, user, pathname])

	return (
		<div className='flex items-center gap-5'>
			Oops, an error occurred!
			<Button variant='outline' onClick={() => resetErrorBoundary()}>
				Try again
			</Button>
		</div>
	)
}

type ErrorMessageProps = {
	user: User
	pathname: string
}
const ErrorMessageMain = ({ user, pathname }: ErrorMessageProps) => {
	const copyToClipboard = () => {
		navigator.clipboard.writeText(
			`role: ${user.role}; username: ${user.username}; \n ${pathname}`
		)
		toast.success('Copied to clipboard')
	}

	return (
		<div className='w-full flex gap-1 items-center justify-between'>
			<p>Copy error message --&gt;</p>
			<button onClick={copyToClipboard} className=''>
				<Copy />
			</button>
		</div>
	)
}

export const ErrorTrigger = () => {
	const [hasError, setHasError] = useState(false)
	if (hasError) throw new Error('Test error')
	return <button onClick={() => setHasError(true)}>Trigger Error</button>
}
